import { useCustom, useOne } from "@refinedev/core";
import { BrandKit, MediaProjectResponse } from "pages/media/types";
import { MediaTiming } from "types";

export const useAnimation = (projectId: string, mediaId?: string) => {
  const { data: projectData, isLoading: isLoadingProject } =
    useOne<MediaProjectResponse>({
      resource: `media/projects`,
      id: projectId,
      queryOptions: {
        enabled: Boolean(projectId),
      },
    });

  const organizationId = projectData?.data?.organization_id;
  const brandKitId = projectData?.data?.settings.brand_kit_id;

  const { data: brandKit } = useOne<BrandKit>({
    resource: `media/${organizationId}/brand_kits`,
    id: brandKitId,
    queryOptions: {
      enabled: Boolean(brandKitId),
    },
  });

  const { data: stepsData } = useCustom<MediaTiming>({
    url: `media/media/${mediaId}/timings`,
    method: "get",
    // don't show errors in case of manual video upload it will return a 500 currently
    errorNotification: false,
    queryOptions: {
      enabled: Boolean(mediaId),
    },
  });
  const hasUploadedVideo =
    projectData?.data?.settings.media_generation_mode === "Disabled";

  const documentId =
    projectData?.data.settings.primary_document_id ??
    projectData?.data?.documents?.[0]?.id;

  const projectDocument = projectData?.data?.documents?.find(
    (x) => x.id === documentId
  );

  const documentAsset = projectDocument;
  const media = projectData?.data.media?.find(
    (mediaItem) =>
      mediaItem.id === (mediaId ?? projectData?.data?.media?.[0]?.id)
  );

  const highlightsAssetPath = projectDocument?.highlights_asset_path;
  const highlightsAssetId = projectDocument?.highlights_asset_id;

  return {
    projectData,
    organizationId,
    brandKit,
    documentAsset,
    documentId,
    media,
    isLoadingProject,
    highlightsAssetPath,
    timingChapters: stepsData?.data?.chapters,
    highlightsAssetId,
    hasUploadedVideo,
  };
};
